module.exports = __webpack_public_path__ + "static/media/backgroundstore.3658bd88.png";